import AsyncCreatableSelect from 'react-select/async-creatable';
import { useEffect, useState } from 'react';

const MedicineList = ({
  setMedName,
  setMedid,
  setMediStrength,
  setMediType, // New prop for updating Medicine Type dropdown
  medListItems,
}) => {
  const [medicines, setMedicines] = useState([]);
  const [options, setOptions] = useState([]);

  // Medicine type options for closest matching logic
  const medicineTypeOptions = [
    'Drop',
    'Fleet Enema',
    'Inhaler',
    'Injections',
    'Nasal Spray',
    'Nebulization',
    'Powder',
    'Cream',
    'Ointments',
    'Suppository',
    'Syrup',
    'Tablet',
    'Capsule',
  ];

  // Function to find closest matching medicine type
  const findClosestMatch = (doseFrom) => {
    if (!doseFrom) return '';

    const lowerDoseFrom = doseFrom.toLowerCase();
    return (
      medicineTypeOptions.find((type) =>
        lowerDoseFrom.includes(type.toLowerCase())
      ) || 'all'
    );
  };

  const fetchMedicine = () => {
    fetch(`${process.env.REACT_APP_AMARLAB_API}/medicine/store-get/?limit=20&ordering=form`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        const newArray = data.results.map((medicine) => {
          return {
            ...medicine,
            value: medicine.name,
            // label: `${medicine.name} — ${medicine.generic} — ${medicine.strength} — ${medicine.form}`,
            label: `${medicine.name} — ${medicine.strength} — ${medicine.form}`,
          };
        });
        setOptions(newArray);
        setMedicines(newArray);
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      });
  };

  useEffect(() => {
    if (!medListItems) {
      fetchMedicine();
    } else {
      setOptions(medListItems);
      setMedicines(medListItems);
    }
  }, []);

  const filterMedicine = async (inputValue) => {
    const respPromise = await fetch(
      `${process.env.REACT_APP_AMARLAB_API}/medicine/store-get/?limit=20&ordering=form&search=${inputValue || ''}`
    ).catch((error) => {
      console.log(error);
    });

    const resp = await respPromise.json();
    const newArray = resp.results.map((medicine) => {
      return {
        ...medicine,
        value: medicine.name,
        // label: `${medicine.name} — ${medicine.generic} — ${medicine.strength} — ${medicine.form}`,
        label: `${medicine.name} — ${medicine.strength} — ${medicine.form}`,

      };
    });
    return newArray;
  };

  const promiseOptions = (inputValue) =>
    new Promise((resolve) => {
      setTimeout(() => {
        resolve(filterMedicine(inputValue));
      }, 1000);
    });

  // Handle medicine selection
  const handleMedName = (e) => {
    setMedName(e.value);
    setMedid(e.id);
    setMediStrength(e.strength);

    // Auto-select closest medicine type based on 'form'
    const closestType = findClosestMatch(e.form); // Assuming 'form' contains dose_from
    setMediType(closestType); // Update parent medicine type dropdown
  };

  const style = {
    control: (base) => ({
      ...base,
      boxShadow: '0 !important',
      minHeight: '46px !important',
      border: '1px solid #fff !important',
    }),
  };

  return (
    <AsyncCreatableSelect
      loadOptions={promiseOptions}
      defaultOptions={options}
      onChange={handleMedName}
      placeholder="Medicine Name"
      styles={style}
    />
  );
};

export default MedicineList;
